import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Grid, Row, Col } from 'react-bootstrap';
import moment from 'moment';
import queryString from 'query-string';

import Layout from '../ui/Layout';
import Loading from '../ui/Loading';
import fetchDux from '../../state/fetch-dux';

import KnowledgeCenterArticleSection from './KnowledgeCenterArticleSection';

class MoreSection extends Component {
  constructor(props) {
    super(props);
    this.state = { showMore: false }
  }
  render() {
    const {
      section,
      sections
    } = this.props;
    const { showMore } = this.state;
    const { textMore, textLess } = section || {};
  
    const nextMoreSectionIndex = (sections || []).findIndex(s => s.__type__ === 'moreSection');
    const sectionsToRender = nextMoreSectionIndex > -1 ? (sections || []).slice(0, nextMoreSectionIndex) : sections;
    const nextSectionsToRender = nextMoreSectionIndex > -1 ? (sections || []).slice(nextMoreSectionIndex) : []

    const toggleShowMore = () => {
      this.setState({ showMore: !showMore });
    }
    return (
      <div className="section-internal-link">
        {showMore && renderSections(sectionsToRender)}
        <a onClick={toggleShowMore}>{showMore ? textLess : textMore}</a>
        {showMore && (nextSectionsToRender || []).length > 0 && renderSections(nextSectionsToRender)}
      </div>
    )
  }
}

const renderSections = sections => {
  const returnArray = []
  for (var i = 0; i < sections.length; i++) {
    const section = sections[i];
    if (section.__type__ === 'moreSection') {
      const nextSections = sections.slice(i + 1);
      returnArray.push(
        <MoreSection sections={nextSections || []} section={section} />
      )
      break;
    }
    returnArray.push(
      <KnowledgeCenterArticleSection key={i} {...section} />
    )
  }

  return returnArray;
};

class KnowledgeCenterArticle extends Component {
  constructor(props) {
    super(props);
    this.state = { isPreview: false };
  }
  componentWillMount() {
    window.scrollTo(0, 0);
    const slug = encodeURIComponent(this.props.match.params[0]);
    const page = `knowledge-center/${slug}`;
    const qs = queryString.parse(this.props.location.search) || {};
    this.props.getContent({
      page,
      preview: qs.preview
    }, null, null, data => {
      if (!(data || {})._id) {
        this.props.history.push('/knowledge-center')
      }
    });
    this.setState({ isPreview: !!qs.preview });
  }
  componentDidUpdate(prevProps) {
    if (this.props.match.params[0] === prevProps.match.params[0]) return;
    const slug = encodeURIComponent(this.props.match.params[0]);
    const page = `knowledge-center/${slug}`;
    this.props.getContent({ page }, null, null, data => {
      if (!(data || {})._id) {
        this.props.history.push('/knowledge-center')
      }
    });
  }
  componentWillUnmount() {
    this.props.clearGetContent();
  }
  render() {
    const { result, inProgress } = this.props;
    const { isPreview } = this.state;

    const { data, assetParent, versionName } = result || {};

    const {
      headerImage,
      author,
      sections,
      title,
      topicHeader
    } = data || {};

    return (
      <Layout
        route="knowledge-center-article"
        isPreview={isPreview}
        versionName={versionName}
        knowledgeCenter
      >
        {inProgress && <Loading />}
        {!inProgress &&
          data &&
          <main>

            <Grid>
              <Row>
                <Col sm={12}>
                  <section className="box-banner">
                    <div
                      style={{
                        backgroundImage: `url(${(headerImage || {}).href})`
                      }}
                    />
                  </section>
                  <article>
                    <div className="date" style={{ textTransform: 'uppercase' }}>
                      {topicHeader}
                    </div>
                    <h1>{title}</h1>
                    <div className="author">Author &mdash; {author}</div>

                    {renderSections(sections || [])}

                    <Link className="link" to="/knowledge-center">
                      Knowledge Center
                    </Link>

                  </article>
                </Col>
              </Row>
            </Grid>

          </main>}
      </Layout>
    );
  }
}

const mapState = state => state.getContent.toJS();

const mapDispatch = dispatch =>
  bindActionCreators(
    {
      getContent: fetchDux.getContent.createAction,
      clearGetContent: fetchDux.getContent.clearAction
    },
    dispatch
  );

export default connect(mapState, mapDispatch)(KnowledgeCenterArticle);



// WEBPACK FOOTER //
// ./src/components/routes/KnowledgeCenterArticle.js